import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from 'components/ui/avatar';
import type { PublishingRosterArtist } from 'types/publishing';
import { ui } from '../ui';

interface Props {
  artists: PublishingRosterArtist[];
  value: string | null;
  onChange: (spotifyArtistId: string) => void;
}

/** Non-admin selector: one button per owned profile, styled like the Profile page's artist bar. */
export function ArtistProfileButtons({ artists, value, onChange }: Props) {
  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        {artists.map((a) => {
          const active = a.spotifyArtistId === value;
          return (
            <button
              key={a.spotifyArtistId}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(a.spotifyArtistId)}
              className={`box-border flex items-center gap-2.5 rounded-[10px] bg-transparent px-3.5 py-2 text-left hover:bg-[#FAFAFA] ${
                active
                  ? 'border-[1.5px] border-[#141414] bg-[#FAFAFA]'
                  : 'border border-[#E9E9E9] hover:border-[#CFCFCF]'
              }`}
            >
              <Avatar className="h-7 w-7">
                <AvatarImage src={a.artistImage || undefined} alt={a.artistName} />
                <AvatarFallback className="bg-[#141414] text-xs font-bold text-white">
                  {a.artistName.slice(0, 1).toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <span
                className={`${ui.body} leading-tight text-[#141414] ${
                  active ? 'font-bold' : 'font-semibold'
                }`}
              >
                {a.artistName}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
